import { MoveToFolderModal } from 'ui/indexPages/modals/MoveToFolderModal';
import { useListTreeViewQuery } from 'modules/listIndex/hooks/folders/useListTreeViewQuery';
import { useMoveToListFoldersModalState } from './hooks/useMoveToListFoldersModalState';

export const MoveToListFolderModal = () => {
  const {
    onClose,
    onConfirm,
    contentItemName,
    currentFolderId,
    rootFolderId,
    contentIds,
    folderIds,
  } = useMoveToListFoldersModalState();

  return (
    <MoveToFolderModal
      onClose={onClose}
      onConfirm={onConfirm}
      contentItemName={contentItemName}
      contentIds={contentIds}
      folderIds={folderIds}
      currentFolderId={currentFolderId}
      rootFolderId={rootFolderId}
      treeViewQuery={useListTreeViewQuery}
    />
  );
};
